const RefreshIcon = (props) => {
    const theme = localStorage.getItem('theme') || 'light'
    const color = theme === 'light' ? 'rgba(53, 100, 217, 1)' : '#FFFFFF'

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.74011 10.9435C4.95095 9.4495 5.63886 8.06362 6.70134 6.99236C7.76381 5.9211 9.14398 5.2218 10.6362 4.99866C12.1284 4.77552 13.6527 5.04049 14.9821 5.75408C16.3115 6.46767 17.3747 7.59169 18.0134 8.95865"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.8866 9.45307L18.8866 9.45307L18.8866 5.45306"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.2931 12.8998C19.0831 14.3879 18.3997 15.7689 17.344 16.8386C16.2883 17.9083 14.9164 18.6098 13.4312 18.8394C11.946 19.069 10.4262 18.8145 9.09685 18.1135C7.76746 17.4126 6.69896 16.3023 6.04939 14.9471"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.14664 14.3902L5.14665 14.3902L5.14664 18.3902"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default RefreshIcon
